<template>
  <div class="site-footer-wrapper">
    <div class="footer-transition" :style="transitionStyle">
      <div class="footer-transition__center"></div>
    </div>
    <footer class="site-footer">
      <div class="footer-links">关于我们&nbsp;│&nbsp;友情链接&nbsp;│&nbsp;意见反馈</div>
      <div class="footer-meta">
        <span>中国社科院新闻所版权所有</span>
        <span>京ICP备号</span>
        <span>京公网安备号</span>
        <span>技术保障</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    notchWidth: {
      type: Number,
      default: 1150
    },
    notchLeft: {
      type: String,
      default: null
    }
  },
  computed: {
    transitionStyle() {
      const width = `${this.notchWidth}px`;
      const left = this.notchLeft || `calc(50vw - ${this.notchWidth / 2}px)`;
      return {
        '--footer-notch-width': width,
        '--footer-notch-left': left
      };
    }
  }
};
</script>

<style scoped>
.site-footer-wrapper {
  width: 100%;
}


.footer-transition {
  width: 100vw;
  height: 90px;
  margin-left: calc(50% - 50vw);
  margin-top: 60px;
  position: relative;
  background-color: #9c1e23;
}

.footer-transition__center {
  position: absolute;
  top: 0;
  left: var(--footer-notch-left);
  width: var(--footer-notch-width);
  height: 90px;
  background-color: #fff;
}

.footer-transition__center::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 18px;
  width: 150px;
  height: 32px;
  margin-left: -80px;
  background-image: url('~@/views/lanhu_shouye/assets/img/SketchPngd7f7e7cdc84545ae7fa953f76adad8f21b6df35db3bbab5dfe84100f4a953a7e.png');
  background-repeat: no-repeat;
  background-size: contain;
}

.footer-transition__center::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 16px;
  background-image: url('~@/views/lanhu_shouye/assets/img/SketchPng6615e0ccb8f98f68987cd244df20264e17a573a9ebf11e78ad491089749946d9.png');
  background-repeat: repeat-x;
  background-size: auto 16px;
  background-position: center bottom;
}

.site-footer {
  background-color: #9c1e23;
  padding: 40px min(100px, 8vw) 30px;
  color: #fdeed9;
  text-align: center;
  width: 100vw;
  margin-left: calc(50% - 50vw);
}

.footer-links {
  font-size: 24px;
  font-family: 'SourceHanSerifCN-SemiBold', serif;
}

.footer-meta {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 24px;
  color: #e1601f;
  font-size: 14px;
}

@media (max-width: 900px) {
  .footer-transition {
    height: 14px;
    margin-top: 24px;
    margin-left: 0;
    background-image: url('~@/views/lanhu_shouye/assets/img/SketchPng6615e0ccb8f98f68987cd244df20264e17a573a9ebf11e78ad491089749946d9.png');
    background-repeat: repeat-x;
    background-size: auto 14px;
    background-position: center bottom;
    background-color: transparent;
  }
  .footer-transition__center {
    display: none;
  }
  .site-footer {
    width: 100%;
    margin-left: 0;
  }
  .footer-meta {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
